import styled from '@emotion/styled'

import { forwardRef, useEffect, useState } from 'react'
import type { PropsWithChildren } from 'react'

import { createPortal } from 'react-dom'

import { useTheme } from '@emotion/react'

import ModalBase, * as Modal from '@segment/matcha/components/Modal'

import type useModal from '@segment/matcha/components/Modal/useModal'

import { ClearIcon } from '@segment/matcha/components/Icons/Common'

import { Loader } from '@segment/matcha/components/Loader/Loader'

import SegmentLogo from '@segment/matcha/components/SegmentLogo'

import { useTrustArcHeightOffset } from '@segment/tracking/useTrustArc'

import usePortal from '@segment/utils/usePortal/usePortal'

interface BaseModalProps {
  getControlCloseProps: ReturnType<typeof useModal>[`getControlCloseProps`]
  opened: boolean
}
const ProductTourModal = forwardRef<HTMLDivElement, PropsWithChildren<BaseModalProps>>(
  ({ opened, getControlCloseProps }, ref) => {
    const theme = useTheme()
    const modalsRoot = usePortal(`modals-root`)
    const [loading, setLoading] = useState(true)
    const trustArcHeightOffset = useTrustArcHeightOffset()

    useEffect(() => {
      if (opened) {
        setLoading(true)
      }
    }, [opened])

    return (
      (opened &&
        createPortal(
          <ModalBase customZIndex={999} fullScreen={true} fullScreenBottomOffset={trustArcHeightOffset} ref={ref}>
            <Modal.Head>
              <SegmentLogo alt="Segment Logo" />
              <StyledClearIcon color={theme.palette.twilio.gray[100]} size="large" {...getControlCloseProps()} />
            </Modal.Head>
            <StyledModalBody>
              <IframeWrapper>
                {loading && <StyledLoader size="xlarge" />}
                <StyledIframe
                  title="Product Tour"
                  src="https://capture.navattic.com/cllviu8af011i08meaa43dxbo"
                  allow="fullscreen"
                  onLoad={() => setLoading(false)}
                />
              </IframeWrapper>
            </StyledModalBody>
          </ModalBase>,
          modalsRoot
        )) ||
      null
    )
  }
)

const StyledClearIcon = styled(ClearIcon)`
  cursor: pointer;
`
const StyledIframe = styled.iframe`
  border: none;
  width: 100%;
  height: 100%;
`

const IframeWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

const StyledModalBody = styled(Modal.Body)`
  overflow: hidden;
`

const StyledLoader = styled(Loader)`
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export default ProductTourModal
